<script setup lang="ts">
  import { useSlots } from "vue";
  import { Text, Button, IconArrowLeft } from "@ui-kit";

  const { title, subtitle, btnTitle } = defineProps<{
    title: string;
    subtitle?: string;
    btnTitle?: string;
  }>();
  const emit = defineEmits<{ "click:btn": [value: void]; "click:back": [value: void] }>();

  const slots = useSlots();
</script>

<template>
  <div class="scan-modal">
    <slot name="icon" class="scan-modal__icon" />
    <div class="scan-modal__header">
      <Text font="body-bold-18" data-testid="scan-modal__title">{{ title }}</Text>
      <Text v-if="subtitle" font="body-regular-14" color="secondary">{{ subtitle }}</Text>
      <span v-else class="scan-modal__subtitle-empty" />
    </div>
    <div class="scan-modal__buttons">
      <slot v-if="slots.buttons" name="buttons" />
      <template v-else>
        <Button
          asSquare
          class="scan-modal__button-back"
          variant="secondary"
          :iconBefore="IconArrowLeft"
          @click="emit('click:back')"
          data-testid="scan-modal-btn-back"
        />
        <Button variant="secondary" class="scan-modal__button-ok" @click="emit('click:btn')" data-testid="scan-modal-btn">
          {{ btnTitle }}
        </Button>
        <slot />
      </template>
    </div>
  </div>
</template>

<style scoped>
  .scan-modal {
    display: flex;
    flex-direction: column;
    margin-top: auto;
    padding: 20px 16px;
    gap: 16px;
    align-items: center;
    background-color: var(--sf-base-background-white);
    border-radius: 16px 16px 0 0;
    box-shadow: var(--sf-shadow-top-s);
  }

  ::slotted(.scan-modal__icon) {
    width: 70px;
    height: 70px;
    stroke: var(var(--sf-base-icon-secondary));
  }

  .scan-modal__header {
    display: flex;
    flex-direction: column;
    gap: 4px;
    text-align: center;
  }

  .scan-modal__subtitle-empty {
    width: 100%;
    height: 36px;
    visibility: hidden;
  }

  .scan-modal__buttons {
    display: flex;
    gap: 8px;
    width: 100%;
  }

  .scan-modal__button-back {
    white-space: nowrap;
    flex-shrink: 0;
  }

  .scan-modal__button-ok {
    flex: 1;
    padding: 14px 15px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
</style>
